import { useEffect, useState } from 'react';
import useAgentsChats from './useAgentsChats';
import { TextFieldWithButtonV2 } from '../common/ai-chat/input-atoms/TextFieldWithButtonV2';
import { useSelector } from 'react-redux';
import { selectActiveChatId } from './agentsChatsReducer';
import { useAgentChatInstance } from './AgentChatInstanceContext';

const AgentInput = ({
  onConfirm,
  isLoading,
  disabled,
  selectedText,
  onClearSelectedText,
  placeholderText,
  renderStopButton,
  onStopClick,
}: {
  onConfirm: (message: string) => Promise<void>;
  isLoading: boolean;
  disabled: boolean;
  selectedText?: string | null;
  onClearSelectedText?: () => void;
  placeholderText?: string;
  renderStopButton?: boolean;
  onStopClick?: () => void;
}) => {
  const [value, setValue] = useState('');
  const { chatInstanceId } = useAgentChatInstance();
  const activeChatId = useSelector(selectActiveChatId(chatInstanceId));
  const { inputPlaceholder: placeholderTextByType } = useAgentsChats();

  //reset the input when switching chats
  useEffect(() => {
    setValue('');
  }, [activeChatId]);

  return (
    <TextFieldWithButtonV2
      value={value}
      setValue={setValue}
      onConfirm={onConfirm}
      inputPlaceholder={placeholderText ?? placeholderTextByType}
      isLoading={isLoading}
      readonly={disabled}
      selectedText={selectedText}
      onClearSelectedText={onClearSelectedText}
      maxInputHeight={400}
      renderStopButton={renderStopButton}
      onStopClick={onStopClick}
    />
  );
};

export default AgentInput;
